import { render, staticRenderFns } from "./examDataTable.vue?vue&type=template&id=6193e2ab&scoped=true"
import script from "./examDataTable.vue?vue&type=script&lang=js"
export * from "./examDataTable.vue?vue&type=script&lang=js"
import style0 from "./examDataTable.vue?vue&type=style&index=0&id=6193e2ab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6193e2ab",
  null
  
)

export default component.exports